import styles from './notFound.scss';
import React, { PureComponent } from 'react';
// import { Link } from 'react-router';
import NotFoundImg from '../../../../images/404.png';

export default class NotFound extends PureComponent {
    render() {
        return (
            <div className={styles.notFound}>
                <img src={NotFoundImg}/>
                <p>页面未找到</p>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/common/error/notFound/NotFound.jsx